import { render, staticRenderFns } from "./HistoryMovieLists.vue?vue&type=template&id=0c2cafea&scoped=true&"
import script from "./HistoryMovieLists.vue?vue&type=script&lang=js&"
export * from "./HistoryMovieLists.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMovieLists.vue?vue&type=style&index=0&id=0c2cafea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cafea",
  null
  
)

export default component.exports